import "../css"

const updateItems = () => {
  const items = document.querySelectorAll('input[name="event[items][]"]')
  if (items.length == 0) return
  let list = ""

  items.forEach(el => {
    list += `<li><b>${el.value}</b></li>`
  })
  document.querySelector(".event ul.triangle").innerHTML = list.replace(/ -- /g, " — ")

  document.querySelector(".event .item-with-blurb").innerHTML = `
    <b>${items[0].value.replace(/ -- /g, " — ")}</b>
    ${document.querySelector('input[name="event[blurb]"]').value}
  `
}

const wrapLink = (content) => {
  const url = document.querySelector("#event_link").value

  if (url == "") {
    return content
  } else {
    return `<a href="${url}" target="_blank">${content}</a>`
  }
}

addEventListener("click", ({ target }) => {
  if (target.matches("#add-item")) {
    const container = document.querySelector("#items")
    const child = container.querySelector("template").content.children[0].cloneNode(true)
    const count = container.childElementCount
    child.querySelector("input").id = `item${count}`
    child.querySelector("label").setAttribute("for", `item${count}`)
    container.appendChild(child)
  }

  if (target.closest(".remove-item")) {
    target.closest(".mb-3").remove()
    updateItems()
  }

  if (target.closest("#clear-image")) {
    document.querySelector("#event_image").value = null
    document.querySelector(".event .col-md-5").remove()
    document.querySelector(".event .col-md-7").classList.remove(".col-md-7")

    if (!document.querySelector('#clear-image + input[type="hidden"]')) {
      target.insertAdjacentHTML("afterend", '<input type="hidden" name="event[image]" value="">')
    }
  }
})

addEventListener("keyup", ({ target }) => {
  if (target.matches("#event_title") || target.matches("#event_link")) {
    const title = document.querySelector("#event_title").value
    document.querySelector(".event .card-title").innerHTML = wrapLink(title)
  }

  if (target.matches("#event_link")) {
    const imgContainer = document.querySelector(".event .col-md-5")
    if (!imgContainer) return

    const imgLink = imgContainer.querySelector("a")

    if (imgLink) {
      imgLink.href = document.querySelector("#event_link").value
    } else {
      imgContainer.innerHTML = wrapLink(document.querySelector(".event img").outerHTML)
    }
  }

  if (target.matches('input[name="event[items][]"]')) {
    updateItems()
  }
})

addEventListener("trix-change", () => {
  updateItems()
})

addEventListener("change", ({ target }) => {
  if (target.matches("#event_image")) {
    document.querySelector('#clear-image + input[type="hidden"]')?.remove()

    const url = URL.createObjectURL(target.files[0])
    const row = document.querySelector(".event .row")
    const img = row.querySelector("img")

    if (img) {
      img.src = url
    } else {
      row.children[0].classList.add("col-md-7")
      row.insertAdjacentHTML("afterbegin", '<div class="col-md-5">' + wrapLink(`<img src=${url} class="img-fluid ps-3 py-3">`) + "</div>")
    }
  }
})
